import { Modal } from "ui/Modal"
import { Text } from "ui/Typography"
import { Flex, Button } from "antd"
import { spacings } from "themes/variables"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

const EmailExistModal = ({ isModalOpen, handleCancel, handleYesEmailExistModal }) => {
  const { t } = useTranslation()

  return (
    <Modal open={isModalOpen} onCancel={handleCancel} title={t("auth.email_exist_modal_title")} width={400} centered>
      <Flex vertical gap={spacings.L}>
        <Text>{t("auth.email_exist_modal_text")}</Text>
        <Flex gap={spacings.XXS} justify="end">
          <Button onClick={handleCancel}>{t("auth.email_exist_modal_cancel")}</Button>
          <Button type="primary" onClick={handleYesEmailExistModal}>
            {t("auth.email_exist_modal_yes")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

EmailExistModal.propTypes = {
  isModalOpen: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleYesEmailExistModal: PropTypes.func
}

export default EmailExistModal
